import * as React from "react";
import {BrowserRouter, Route,Routes} from "react-router-dom";
import './App.css';
import LeadForm from "./pages/LeadForm";


function App() {

    return (
        <BrowserRouter >
            <Routes>
                <Route path="/" element={<LeadForm/>} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
